import { Maybe } from "@graphql-tools/utils";
import * as Yup from "yup";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { GeneralFieldController } from "./general-field-controller";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

export class MedicalHistoryFieldController extends GeneralFieldController {
	override createValidationRule(_initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return super.createFieldValidationRuleByDataType(translation);
	}

	override mapInitialValue(value: unknown): unknown {
		return (
			value ||
			this.parent.context.startingPoint?.data[AttributeIdentifiers.MedicalHistory as any] ||
			""
		);
	}

	override useControlProps(path: string): Maybe<FlexControlProps> | undefined {
		return {
			controlType: "textArea",
		};
	}
}
